module.exports = __webpack_public_path__ + "media/images/icon__twitter@2x-72b17e37708b950fde697182ceffc0a7.png";